import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./buildings-table.scss";
import {keyed} from "../../../../../../../../react/keyed";
import {NormalView} from "./normal-view/normal-view";
import {SearchView} from "./search-view/search-view";

export const BuildingsTable1 = ({buildings, onRemoveBuilding, onAddBuilding, onRemoveAddresses, search}) => cs(
    keyed(search),

    () => !search ? (
        NormalView({
            buildings,
            onRemoveBuilding,

            onAddBuilding,
            onRemoveAddresses,
        })
    ) : (
        SearchView({
            buildings,
            onRemoveBuilding,

            onAddBuilding,
            search,
            onRemoveAddresses,
        })
    ),

);



